import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';
import { LoaderService } from 'src/app/service/loader.service';
import { ResponseData } from 'src/app/service/model/response.model';
import { WorkflowDto } from 'src/app/model/core/workflowDto';

@Component({
  selector: 'app-work-flow',
  templateUrl: './work-flow.component.html',
  styleUrls: ['./work-flow.component.scss']
})
export class WorkFlowComponent implements OnInit {
  workflows: WorkflowDto[] = [];
  roleId: number = 7;
  constructor(private commonService: CommonService, private loader: LoaderService) { }

  ngOnInit(): void {
    this.loadWorkflows();
  }

  loadWorkflows() {
    this.loader.show();
    const filter = { RoleId: this.roleId };
    this.commonService.GetWorkFlow(filter).subscribe((res: ResponseData) => {
      this.loader.hide();
      if (res && res.successed) {
        this.workflows = res.data as WorkflowDto[];
      }
    }, err => {
      this.loader.hide();
    });
  }
}
